import { GoSearch } from "react-icons/go";
import { IoIosClose } from "react-icons/io";
import styled from "styled-components";
import { useMainContext } from "../../../contexts/main";


const SearchBox = (props) => {

  const { main: { lang } } = useMainContext()

  const {
    width, height, bgColor,
    searchValue, onInputValueChange, onCloseSearchClicked, onKeyDown
  } = props

  return (
    <SearchBar height={height} width={width} {...props}>
      <SearchContainer  bgColor={bgColor}>
        <SearchIcon />
        <SearchInput
          onKeyDown={onKeyDown ? onKeyDown : () => { }}
          placeholder={lang === "en" ? "Search" : "جستجو"}
          value={searchValue}
          onChange={onInputValueChange}
        />
        {searchValue !== "" && <CloseSearchIcon onClick={onCloseSearchClicked} />}
      </SearchContainer>
    </SearchBar>
  )
}

const SearchBar = styled.div`
  height: ${props => props.height || "40px"};
  width: ${props => props.width || "95%"};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const SearchContainer = styled.div`
    width: ${props => props.width || "95%"};
    height: 70%;
    border-radius: 5px;
    display: flex;
    background-color: ${(props) => props.bgColor || props.theme.tInputBg};
    align-items: center;
    padding: ${(props) => (props.theme.english && "5px") || "2px"};
`;


const SearchInput = styled.input`
  height: 75%;
  width: 100%;
  background-color: transparent;
  color: ${props => props.theme.secondary};
  border: none;
  padding: 4px;
  letter-spacing: 1.3px;
`;


const SearchIcon = styled(GoSearch)`
  color: ${(props) => props.theme.color};
  width: 16px;
  height: 16px;
  margin: 0 4px;
`;

const CloseSearchIcon = styled(IoIosClose)`
  color: ${(props) => props.theme.color};
  width: 22px;
  height: 22px;
  margin: 0 4px;
  cursor: pointer;
`;


export default SearchBox;
